export const pdpSizes = [
  '2.5',
  '3',
  '3.5',
  '4',
  '4.5',
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10',
  '10.5',
  '11',
  '11.5',
  '12',
  '12.5',
  '13',
  '13.5',
  '14',
  '14.5',
  '15',
  '15.5'
];

export const allSizes = [...pdpSizes, '16', '16.5', '17', '17.5', '18'];

export const sizeSixVariants = [
  '6(EU-39)',
  '6(EU-40)',
  '6 (EU 39)',
  '6 (EU 40)',
  '6'
];
